// mobileButtons.ts
export function initStickyButton(
    buttonSelector: string,
    footerSelector: string = 'footer'
): void {
    const cta = document.querySelector<HTMLElement>(buttonSelector);
    if (!cta) return;

    const footer = document.querySelector<HTMLElement>(footerSelector);
    let originalOffsetTop: number | null = null;

    const measureOriginalOffset = (): void => {
        const wasStatic = cta.classList.contains('is-static');
        cta.classList.add('is-static');
        originalOffsetTop = cta.getBoundingClientRect().top + window.scrollY;
        if (!wasStatic) cta.classList.remove('is-static');
    };

    const onScroll = (): void => {
        if (originalOffsetTop === null) return;

        const scrollY = window.scrollY;
        const windowHeight = window.innerHeight;
        const footerTop = footer
            ? footer.getBoundingClientRect().top + window.scrollY
            : Infinity;

        const atNaturalPosition =
            scrollY + windowHeight >= originalOffsetTop + cta.offsetHeight;
        const hittingFooter = scrollY + windowHeight >= footerTop;

        const shouldBeStatic = atNaturalPosition || hittingFooter;

        if (shouldBeStatic) {
            cta.classList.remove('is-fixed');
            cta.classList.add('is-static');
        } else {
            cta.classList.remove('is-static');
            cta.classList.add('is-fixed');
        }
    };

    window.addEventListener('load', () => {
        measureOriginalOffset();
        onScroll();
    });

    window.addEventListener('resize', () => {
        measureOriginalOffset();
        onScroll();
    });

    document.addEventListener('scroll', onScroll, { passive: true });
}

export function initDisappearingButton(
    buttonSelector: string,
    stopAtSelector: string
): void {
    const button = document.querySelector<HTMLElement>(buttonSelector);
    const stopElement = document.querySelector<HTMLElement>(stopAtSelector);

    if (!button || !stopElement) return;

    let originalOffsetTop: number;

    const measureOriginalOffset = (): void => {
        originalOffsetTop = button.getBoundingClientRect().top + window.scrollY;
    };

    const onScroll = (): void => {
        const scrollY = window.scrollY;
        const stopTop = stopElement.getBoundingClientRect().top + window.scrollY + 200; // Adding a buffer of 200px as it was dissappearing too early

        if (scrollY + window.innerHeight >= stopTop) {
            button.classList.remove('is-fixed');
            button.classList.add('is-hidden');
        } else {
            button.classList.remove('is-hidden');
            button.classList.add('is-fixed');
        }
    };

    window.addEventListener('load', () => {
        measureOriginalOffset();
        onScroll();
    });

    window.addEventListener('resize', () => {
        measureOriginalOffset();
        onScroll();
    });

    document.body.addEventListener('scroll', onScroll);
}
